export function isValidFile(input) {
  return "File" in window && input instanceof File;
}
